require('./general');
import Sortable from 'sortablejs';
window.BaguetteBox = require('baguettebox.js');
window.Siema = require('siema');
window.DatePickerX = require('datepickerx/src/js/DatePickerX');
window.Pell = require('pell');
window.braintree = require('braintree-web');
window.paypal = require('paypal-checkout');
window.purchase = require('./purchases');
window.Sortable = Sortable;
window.Clipboard = require('clipboard');
window.Isotope = require('isotope-layout');
window.IsotopePackery = require('isotope-packery');
window.ImagesLoaded = require('imagesloaded');
window.FileDownloader = require('js-file-downloader');
window.Tobbi = require('tobii');

const dropzone = require('dropzone');
dropzone.Dropzone.autoDiscover = false;

window.Dropzone = dropzone;



// WEBPACK FOOTER //
// ./resources/assets/js/app.js